import __C from '@/primitives/_constant_'
import __M from 'moment'
import { h } from 'vue'
import { createRouter, createWebHashHistory,RouterView } from 'vue-router'

const routes = [
  {
    path     : '/',
    redirect : '/tools',
    component: () => import('../App'),
    children : [
      {
        path      : 'login',
        name      : 'Login',
        component : () => import('../views/login'),
        beforeEnter(from, to, next) {
          const account = JSON.parse(localStorage.getItem('ACCOUNT'))
          if (account) return next({ path: '/tools', replace: true })
          next()
        },
      },
      {
        path      : 'tools',
        name      : 'Tools',
        component : () => import('../views/tools')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: 'open active',
  routes:routes
})

router.beforeEach((to, from, next) => {
  let timeout = localStorage.getItem(__C.LOCAL_STORAGE_NAME.TIMEOUT)
  let account = JSON.parse(localStorage.getItem(__C.LOCAL_STORAGE_NAME.ACCOUNT))

  let authRequired = true
  let pathEl = to.path.split('/')[1];
  [{ name: 'login' }].forEach(url => { 
    if(pathEl == url.name) {
      authRequired = false
    }
  })

  if (account && (!timeout || __M().diff(__M(timeout, 'YYYY-MM-DD HH:mm:ss'), 'minutes') > __C.CONFIG.TIMEOUT)) {
    localStorage.removeItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)
  }
  if (authRequired && !account) {
    return next({ path: '/login', replace: true })
  } 
  next()
})

export default router